export default "__VITE_ASSET__78f7d365__"